import { render } from "./ManageClientTasks.vue?vue&type=template&id=f41c7736"
import script from "./ManageClientTasks.vue?vue&type=script&setup=true&lang=js"
export * from "./ManageClientTasks.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/Pages/Admin/ManageClientTasks.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "f41c7736"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('f41c7736', __exports__)) {
    api.reload('f41c7736', __exports__)
  }
  
  module.hot.accept("./ManageClientTasks.vue?vue&type=template&id=f41c7736", () => {
    api.rerender('f41c7736', render)
  })

}


export default __exports__